export function getAstroData(state) {
  return state.astrologicalSlice;
}
